import React, { useEffect, useRef } from 'react';
import { AppContext } from '../../App';
import Loader from '../../common/Loader';
import { useFetchFavouriteMatchesData } from '../../data/fetchFavouriteMatchesData';
import { parseMatchData } from '../../data/parseMatchData';
import { classIf } from '../../data/utils/classIf';
import { toggleFavouriteMatchInStorage } from '../../data/utils/toggleFavouriteMatchInStorage';
import { LiveContext } from '../Live';
import LiveSporstNav from '../live-suite/LiveSportsNav';
import FavoritesSport from './FavoritesSport';
import { isOverlaySection } from '../../utils/sport-effects';
import { labels } from '../../data/labels';

function Favorites(props) {
    const appContext = React.useContext(AppContext);
    const liveContext = React.useContext(LiveContext);
    const noData = useRef(true);

    function changeSport(sportId) {
        liveContext.openLiveSuite(sportId);
    }
    
    const favorites = liveContext.favorites;
    const noFavorites = Object.keys(favorites).length === 0;
    const [state] = useFetchFavouriteMatchesData(favorites, true, !noFavorites);
    
    useEffect(() => {
        if (state.data != null) {
            if (noData.current) {
                noData.current = false;
            }
            const favsToRemove = [];
            for (let matchId in favorites) {
                const match = favorites[matchId];
                const key = match.pal + '_' + match.avv;
                // If match data is null, remove match from favorites
                if (state.data[key] === undefined) {
                    favsToRemove.push(match.uniqueId);
                    toggleFavouriteMatchInStorage(match.uniqueId, match, match.idAggregata);
                } else {
                    const matchData = JSON.parse(state.data[key]);
                    if (matchData.ags.find(ag => ag === match.idAggregata) === undefined) {
                        // The main bet group is closed, so I show the locks in place of the odds
                        match.bets.forEach(bet => {
                            bet.odds.forEach(odd => odd.value = null);
                        });
                    } else {
                        const parsedData = parseMatchData(matchData, match.idAggregata, match, true);
                        favorites[matchId] = {
                            ...match,
                            ...parsedData,
                        };
                    }
                }
            }
            favsToRemove.forEach(matchId => {
                delete favorites[matchId];
            });
            liveContext.setFavorites(favorites);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state]);

    if ((!noFavorites && noData.current) || state.isError) {
        return <Loader error={state.isError} />;
    }
    
    const sports = {};
    const matchesBySport = {};
    if (!noFavorites) {
        Object.values(favorites).forEach(match => {
            const sportRef = match.sportRef;
            if (sports[sportRef] === undefined) {
                sports[sportRef] = {};
            }
            const matchesByTournament = sports[sportRef];
            if (matchesByTournament[match.tournamentRef] === undefined) {
                matchesByTournament[match.tournamentRef] = [];
            }
            matchesByTournament[match.tournamentRef].push(match);

            if (matchesBySport[sportRef] === undefined) {
                matchesBySport[sportRef] = [];
            }
            matchesBySport[sportRef].push(match);
        });
    }
    const hideWrapper = isOverlaySection(appContext,props.section);

    return (
        <div id="main-wrapper" className={"wrapper" + classIf(hideWrapper, 'no-scroll d-none')}>
            <div id="main-container" className="main-content">
                <LiveSporstNav sports={liveContext.sports} changeSport={changeSport} />
                {noFavorites ?
                    <div className="message-box">
                        <span className="list-element-text">{labels['general.no_favorites']}</span>
                    </div>
                    :
                    <>
                        {Object.keys(sports).map(sportId => {
                            const sportTournaments = Object.values(sports[sportId]);
                            const sportMatches = Object.values(matchesBySport[sportId]);
                            return (
                                <FavoritesSport key={sportId} tournaments={sportTournaments} matches={sportMatches} />
                            )
                        })}
                    </>
                }
            </div>
        </div>
    );
}

export default Favorites;